var _path, _path2, _path3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarrefourGolden(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 30,
    viewBox: "0 0 33 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9556 0.78971C15.1721 1.05066 14.4249 1.4109 13.7319 1.86174C9.85641 4.28635 8.12018 8.73553 7.94449 13.0427C7.93243 13.2886 7.93071 13.5328 7.93071 13.7753V13.7753C7.93071 13.7978 7.93071 13.9225 7.93071 13.964V29.2668H12.9723V13.9675C12.9707 13.0394 13.3805 12.1589 14.0902 11.5654L16.0796 13.9675L18.0656 11.5671C18.7755 12.1599 19.1859 13.0397 19.1852 13.9675V29.2703H24.2251V13.9675C24.2285 11.2508 22.8918 8.70919 20.6568 7.18259C18.4218 5.65599 15.5794 5.34309 13.0688 6.34728V6.34728C14.1023 5.13497 15.6525 4.52362 17.3646 4.48725V4.48725C17.9101 4.47597 18.4554 4.51948 18.9923 4.61714C23.4535 5.35145 26.8519 9.12 26.8691 13.6454C26.8691 13.8186 26.8812 13.9918 26.8812 14.1649V29.2599H31.9245V14.0489C31.9245 7.45568 27.9835 2.17001 21.2677 0.595741C21.0231 0.538589 20.6338 0.460655 20.2859 0.413894C19.7787 0.339671 19.2671 0.299173 18.7546 0.292664C17.7999 0.29281 16.8526 0.461032 15.9556 0.78971V0.78971Z",
    fill: "#BD9E56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0299 0C6.18065 0 0 5.91156 0 13.7583V29.2674H5.13564C5.13564 29.2674 5.13564 20.7357 5.13564 13.7461C5.13564 6.45229 10.7149 1.24838 16.3152 0.11997C16.5431 0.0712864 16.8096 0 16.5431 0L15.0299 0Z",
    fill: "#BD9E56"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12322_498",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 30
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0299 0C6.18065 0 0 5.91156 0 13.7583V29.2674H5.13564C5.13564 29.2674 5.13564 20.7357 5.13564 13.7461C5.13564 6.45229 10.7149 1.24838 16.3152 0.11997C16.5431 0.0712864 16.8096 0 16.5431 0L15.0299 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12322_498)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarrefourGolden);
export default __webpack_public_path__ + "static/media/carrefour-golden.fc300e05aff155f86d3f1f02a197425f352b6fb8b0a5434ee4620904ea87c9b8.svg";
export { ForwardRef as ReactComponent };